import React from "react";
import Chip from '@mui/material/Chip';

export function MuiChip({ name, value, label, variant, onClick }) {
    const handleClick = () => {
        let event = {};
        event.target = {
            name: name,
            value: value
        }
        onClick(event)
    }
    return <Chip label={label} variant={variant} onClick={handleClick} />
}